<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="1600px" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleClose" top="5vh">
    <div class="dialog-content">
      <!-- 头部信息区域 -->
      <div class="header-section" style="width: 1480px !important;">
        <div class="section-title">基本信息</div>
        <el-form ref="headerForm" :model="headerForm" :rules="headerRules" label-width="140px" size="small">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compCode">
                <el-select v-model="headerForm.compCode" placeholder="请选择客户名称" filterable clearable style="width: 100%" @change="handleCustomerChange" @focus="loadCustomerOptions">
                  <el-option v-for="item in customerOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务联系人" prop="contactPerson">
                <el-input v-model="headerForm.contactPerson" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务联系电话" prop="contactPhone">
                <el-input v-model="headerForm.contactPhone" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票主体" prop="invoiceEntity">
                <el-input v-model="headerForm.invoiceEntity" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">

            <el-col :span="8">
              <el-form-item label="返点方案" prop="rebatePlan">
                <el-input :value="getRebateText(Number(headerForm.rebatePlan))" placeholder="自动填充" style="width: 100%" disabled />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="跟单员" prop="followUpPerson">
                <el-input v-model="headerForm.followUpPerson" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="项目来源" prop="projectSource">
                <el-input v-model="headerForm.projectSource" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="8">
              <el-form-item label="状态" prop="status">
                <el-input v-model="headerForm.status" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col> -->
          </el-row>

          <!-- 返点方案详细配置 -->
          <el-row :gutter="20">

          </el-row>
          <!-- 返点方案type=1：固定百分比 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 1 || headerForm.rebatePlan === '1'">
            <el-col :span="8">
              <el-form-item label="开始日期">
                <el-date-picker v-model="headerForm.fixedRebateStart" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束日期">
                <el-date-picker v-model="headerForm.fixedRebateEnd" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="返点百分比">
                <el-input v-model="headerForm.ratioValue" placeholder="请输入百分比(如50)" clearable disabled>
                  <template slot="suffix">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="headerForm.fixedRebateRemark" placeholder="请输入备注" clearable disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=2：按检测日期以及层数不同百分比 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 2 || headerForm.rebatePlan === '2'">
            <el-col :span="24">
              <el-form-item label="返点百分比设置">
                <el-table :data="headerForm.rebateTiers" border size="small" style="width: 100%;">
                  <el-table-column label="开始日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="结束日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="层数" width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.level" placeholder="请输入层数" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="(含当前层)以下折扣为" width="220">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层(含当前层)以下折扣为</span>
                        <el-input v-model="scope.row.belowPercent" placeholder="请输入百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="以上折扣为" width="200">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层以上折扣为</span>
                        <el-input v-model="scope.row.abovePercent" placeholder="请输入百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=3：固定单台费用 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 3 || headerForm.rebatePlan === '3'">
            <el-col :span="8">
              <el-form-item label="开始日期">
                <el-date-picker v-model="headerForm.fixedRebateStart" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束日期">
                <el-date-picker v-model="headerForm.fixedRebateEnd" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单台返点金额">
                <el-input v-model="headerForm.unitRebateAmount" placeholder="请输入金额" clearable disabled>
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="headerForm.fixedRebateRemark" placeholder="请输入备注" clearable disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=4：按层数不同百分比及固定单台返点 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 4 || headerForm.rebatePlan === '4'">
            <el-col :span="24">
              <el-form-item label="返点配置">
                <el-table :data="headerForm.rebateTiers" border size="small" style="width: 100%;">
                  <el-table-column label="开始日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="结束日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="层数" width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.level" placeholder="请输入层数" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="(含当前层)以下百分比" width="220">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层(含)以下</span>
                        <el-input v-model="scope.row.belowPercent" placeholder="百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="以上单台金额" width="180">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层以上</span>
                        <el-input v-model="scope.row.aboveUnitPrice" placeholder="金额" disabled>
                          <template slot="suffix">元</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <!-- 详细信息列表区域 -->
      <div class="detail-section">
        <div class="section-title">
          <span>详细信息</span>
          <div class="section-actions">
            <div class="batch-edit-control">
              <span>批量编辑</span>
              <el-switch v-model="batchEditMode" />
            </div>
            <el-upload ref="excelUpload" action="" :auto-upload="false" :show-file-list="false" :on-change="handleExcelImport" accept=".xlsx,.xls" :disabled="isEdit">
              <el-button size="small" type="primary" icon="el-icon-upload2" :disabled="isEdit">详细信息导入</el-button>
            </el-upload>
            <el-button size="small" type="success" icon="el-icon-plus" @click="handleAddRow" :disabled="isEdit">新增</el-button>

          </div>
        </div>

        <el-table :data="detailList" border stripe size="small" max-height="400" style="width: 100%; margin-top: 10px" height="260">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="现场联系人" min-width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.siteContact" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'siteContact')"
                        @keyup.enter.native="handleBatchColumnSync('siteContact', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="现场联系人电话" min-width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.siteContactTel" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'siteContactTel')"
                        @keyup.enter.native="handleBatchColumnSync('siteContactTel', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="使用单位" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.usingUnit" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'usingUnit')"
                        @keyup.enter.native="handleBatchColumnSync('usingUnit', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="小区名称" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.houseName" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'houseName')"
                        @keyup.enter.native="handleBatchColumnSync('houseName', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="识别码" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OIDNO" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'OIDNO')"
                        @keyup.enter.native="handleBatchColumnSync('OIDNO', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="统一信用代码" min-width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unifiedCreditCode" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'unifiedCreditCode')"
                        @keyup.enter.native="handleBatchColumnSync('unifiedCreditCode', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="到检年月" min-width="140">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.inspectionMonth" type="month" placeholder="选择年月" value-format="yyyy-MM" format="yyyy年MM月" size="small" style="width: 100%"
                              :disabled="isDetailCellDisabled(scope.$index, 'inspectionMonth')" @change="handleBatchColumnSync('inspectionMonth', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="单位使用地址" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.USE_UNT_ADDR" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'USE_UNT_ADDR')"
                        @keyup.enter.native="handleBatchColumnSync('USE_UNT_ADDR', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="折扣" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finalDisc" placeholder="0-1(不含0)" size="small" @input="handleDiscInput(scope.row)" :disabled="isDetailCellDisabled(scope.$index, 'finalDisc')"
                        @keyup.enter.native="handleBatchColumnSync('finalDisc', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="固定价" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finalPrice" placeholder="请输入" size="small" @input="handlePriceInput(scope.row)" :disabled="isDetailCellDisabled(scope.$index, 'finalPrice')"
                        @keyup.enter.native="handleBatchColumnSync('finalPrice', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" size="small" :disabled="isDetailCellDisabled(scope.$index, 'remark')"
                        @keyup.enter.native="handleBatchColumnSync('remark', scope.$index)" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDeleteRow(scope.$index)" :disabled="isEdit" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryCustBaseList, queryCustBaseDetail, queryCustInfo, saveCustInfo, updateCustInfo, getBatchDetail } from '@/api/contract/contract.js'
import * as XLSX from 'xlsx'

export default {
  name: 'AddAndEdit',

  data () {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      isSingleEdit: false,
      batchEditMode: false,
      editId: '',

      // 客户选项列表
      customerOptions: [],
      customerLoading: false,

      // 头部表单数据
      headerForm: {
        compCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        followUpPerson: '',
        projectSource: '',
        invoiceEntity: '',
        status: '',
        rebatePlan: '',
        // 返点方案相关字段
        ratioValue: '',
        fixedRebateStart: '',
        fixedRebateEnd: '',
        fixedRebateRemark: '',
        unitRebateAmount: '',
        rebateTiers: []
      },

      // 头部表单验证规则
      headerRules: {
        compCode: [
          { required: true, message: '请选择客户名称', trigger: 'change' }
        ]
      },

      // 详细信息列表
      detailList: []
    }
  },
  computed: {
    dialogTitle () {
      return this.isEdit ? '修改委托信息' : '新增委托信息'
    }
  },
  methods: {
    // 状态映射
    getStatusText (status) {
      switch (status) {
        case 'ongoing': return '进行中'
        case 'completed': return '完结'
        default: return '未知'
      }
    },
    // 返点方案映射
    getRebateText (rebateType) {
      switch (rebateType) {
        case 1: return '固定百分比'
        case 2: return '按检测日期以及层数不同百分比'
        case 3: return '固定单台费用'
        case 4: return '按层数不同百分比及固定单台返点'
        default: return ''
      }
    },
    /**
     * 加载返点配置
     */
    loadRebateConfig (d, base) {
      // 清空返点配置
      this.headerForm.ratioValue = ''
      this.headerForm.fixedRebateStart = ''
      this.headerForm.fixedRebateEnd = ''
      this.headerForm.fixedRebateRemark = ''
      this.headerForm.unitRebateAmount = ''
      this.headerForm.rebateTiers = []

      // 设置返点方案
      const rebateTypeRaw = (d && d.rebateType != null) ? d.rebateType : (base ? base.rebateType : undefined)
      const rebateType = (rebateTypeRaw !== undefined && rebateTypeRaw !== '') ? Number(rebateTypeRaw) : null
      this.headerForm.rebatePlan = rebateType != null ? rebateType : ''

      // 解析返点配置
      const rebateList = d.rebateList || base.rebateList || []
      if (rebateType === 1 && Array.isArray(rebateList) && rebateList.length > 0) {
        // 固定返点
        const rebate = rebateList[0]
        this.headerForm.ratioValue = rebate.ratioValue || ''
        this.headerForm.fixedRebateStart = this.formatDate(rebate.beginDate) || ''
        this.headerForm.fixedRebateEnd = this.formatDate(rebate.endDate) || ''
        this.headerForm.fixedRebateRemark = rebate.remark || ''
      } else if (rebateType === 2 && Array.isArray(rebateList)) {
        // 按层数返点
        const rebateMap = {}
        rebateList.forEach(item => {
          const floorNum = parseInt(item.floorNum, 10)
          if (isNaN(floorNum)) return
          const beginDate = this.formatDate(item.beginDate) || ''
          const endDate = this.formatDate(item.endDate) || ''
          if (floorNum < 0) {
            const level = Math.abs(floorNum)
            rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', abovePercent: '', remark: item.remark || '' }
            rebateMap[level].belowPercent = item.ratioValue || ''
          } else {
            const level = floorNum - 1
            if (level >= 0) {
              rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', abovePercent: '', remark: item.remark || '' }
              rebateMap[level].abovePercent = item.ratioValue || ''
            }
          }
        })
        this.headerForm.rebateTiers = Object.keys(rebateMap).sort((a, b) => Number(a) - Number(b)).map(k => rebateMap[k])
      } else if (rebateType === 3 && Array.isArray(rebateList) && rebateList.length > 0) {
        // 固定单台费用
        const rebate = rebateList[0]
        this.headerForm.unitRebateAmount = rebate.unitPrice || rebate.unitAmount || rebate.ratioValue || ''
        this.headerForm.fixedRebateStart = this.formatDate(rebate.beginDate) || ''
        this.headerForm.fixedRebateEnd = this.formatDate(rebate.endDate) || ''
        this.headerForm.fixedRebateRemark = rebate.remark || ''
      } else if (rebateType === 4 && Array.isArray(rebateList)) {
        // 按层数不同百分比及固定单台返点
        const rebateMap = {}
        rebateList.forEach(item => {
          const floorNum = parseInt(item.floorNum, 10)
          if (isNaN(floorNum)) return
          const beginDate = this.formatDate(item.beginDate) || ''
          const endDate = this.formatDate(item.endDate) || ''
          if (floorNum < 0) {
            // 层数以下用百分比
            const level = Math.abs(floorNum)
            rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', aboveUnitPrice: '', unitAmount: item.unitAmount || '', remark: item.remark || '' }
            rebateMap[level].belowPercent = item.ratioValue || ''
          } else {
            // 层数以上用固定单台费用
            const level = floorNum - 1
            if (level >= 0) {
              rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', aboveUnitPrice: '', unitAmount: item.unitAmount || '', remark: item.remark || '' }
              rebateMap[level].aboveUnitPrice = item.unitPrice || item.unitAmount || ''
            }
          }
        })
        this.headerForm.rebateTiers = Object.keys(rebateMap).sort((a, b) => Number(a) - Number(b)).map(k => rebateMap[k])
      }
    },
    /**
     * 解析返点列表，兼容字符串和数组
     */
    parseRebateList (rebateList, sourceName) {
      if (Array.isArray(rebateList)) return rebateList
      if (typeof rebateList === 'string' && rebateList) {
        try {
          const parsed = JSON.parse(rebateList)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          console.error(`解析${sourceName}失败:`, e)
          return []
        }
      }
      return []
    },
    /**
     * 组装编辑态返点配置（含多来源兜底）
     */
    buildEditRebateData ({ rebateSources, rebateTypeSources }) {
      let rebateList = []
      for (let i = 0; i < rebateSources.length; i++) {
        const source = rebateSources[i]
        rebateList = this.parseRebateList(source.value, source.name)
        if (rebateList.length > 0) break
      }
      if (rebateList.length === 0) return null
      const rebateTypeSource = rebateTypeSources.find(v => v !== undefined && v !== null && v !== '')
      return {
        rebateList,
        rebateType: rebateTypeSource || rebateList[0].type
      }
    },
    /**
     * 格式化日期
     */
    formatDate (dateStr) {
      if (!dateStr) return ''
      if (typeof dateStr === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr
        const date = new Date(dateStr)
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }
      }
      return dateStr
    },
    /**
     * 等待客户下拉选项加载完成
     */
    waitForCustomerOptions () {
      return new Promise((resolve) => {
        if (this.customerOptions && this.customerOptions.length > 0 && !this.customerLoading) {
          resolve()
          return
        }
        this.loadCustomerOptions()
        let tries = 0
        const timer = setInterval(() => {
          tries++
          if ((this.customerOptions && this.customerOptions.length > 0 && !this.customerLoading) || tries > 40) {
            clearInterval(timer)
            resolve()
          }
        }, 100)
      })
    },
    /**
     * 加载客户名称选项列表
     */
    loadCustomerOptions () {
      if (this.customerLoading) return
      this.customerLoading = true

      const payload = { currPage: 1, pageSize: 500 }
      queryCustBaseList(payload).then(res => {
        this.customerLoading = false
        const list = (res && res.additionalData && Array.isArray(res.additionalData.records)) ? res.additionalData.records : []
        const mappedList = list.map(item => {
          const status = (item.enabledState === 0 ? 'completed' : 'ongoing')
          return {
            value: item.compCode || '',
            label: item.compName || '',
            data: {
              compCode: item.compCode || '',
              customerName: item.compName || '',
              contactPerson: item.contactPerson || '',
              contactPhone: item.contactTel || '',
              followUpPerson: item.followPerson || '',
              projectSource: item.projectSource || '',
              invoiceEntity: item.compEntityName || '',
              status: this.getStatusText(status),
              rebatePlan: item.rebateType || '',
              rebateType: item.rebateType,
              rebateList: Array.isArray(item.rebateList) ? item.rebateList : []
            }
          }
        })
        // 根据 compName 去重
        const nameMap = new Map()
        this.customerOptions = mappedList.filter(item => {
          const compName = item.label || ''
          if (!nameMap.has(compName)) {
            nameMap.set(compName, true)
            return true
          }
          return false
        })
      }).catch(err => {
        this.customerLoading = false
        console.error(err)
        this.$message.error('获取客户列表失败')
      })
    },
    /**
     * 客户名称改变事件
     */
    handleCustomerChange (value) {
      if (!value) {
        this.headerForm.compCode = ''
        this.headerForm.customerName = ''
        // this.headerForm.contactPerson = ''
        // this.headerForm.contactPhone = ''
        this.headerForm.followUpPerson = ''
        this.headerForm.projectSource = ''
        this.headerForm.invoiceEntity = ''
        this.headerForm.status = ''
        this.headerForm.rebatePlan = ''
        this.headerForm.ratioValue = ''
        this.headerForm.fixedRebateStart = ''
        this.headerForm.fixedRebateEnd = ''
        this.headerForm.fixedRebateRemark = ''
        this.headerForm.unitRebateAmount = ''
        this.headerForm.rebateTiers = []
        this.detailList = []
        return
      }

      const selectedCustomer = this.customerOptions.find(item => String(item.value) === String(value))
      if (selectedCustomer && selectedCustomer.data) {
        const data = selectedCustomer.data
        this.headerForm.customerName = data.customerName || ''
        // this.headerForm.contactPerson = data.contactPerson || ''
        // this.headerForm.contactPhone = data.contactPhone || ''
        this.headerForm.followUpPerson = data.followUpPerson || ''
        this.headerForm.projectSource = data.projectSource || ''
        this.headerForm.invoiceEntity = data.invoiceEntity || ''
        this.headerForm.status = data.status || ''
        // 加载返点配置
        this.loadRebateConfig(data, {})
      }
    },
    /**
     * 确保编辑态下下拉中存在当前客户选项（避免仅显示编码）
     */
    ensureCurrentCustomerOption (compCode, customerName, extraData = {}) {
      if (!compCode) return
      const value = String(compCode)
      const label = customerName || value
      const exists = this.customerOptions.some(item => String(item.value) === value)
      if (exists) return
      this.customerOptions.unshift({
        value,
        label,
        data: {
          compCode: value,
          customerName: label,
          ...extraData
        }
      })
    },
    /**
     * 折扣输入时限制只能输入 0-1 之间的小数（不含 0）
     */
    isDiscInputDisabled (row) {
      return !!row.finalPrice
    },
    isPriceInputDisabled () {
      return false
    },
    /**
     * 详细信息单元格是否禁用（含批量编辑模式）
     */
    isDetailCellDisabled (rowIndex, field) {
      const row = this.detailList[rowIndex]
      if (!row) return false
      if (this.batchEditMode && rowIndex > 0) return true
      if (field === 'usingUnit' || field === 'OIDNO') return this.isEdit
      if (field === 'finalDisc') return this.isDiscInputDisabled(row)
      if (field === 'finalPrice') return this.isPriceInputDisabled()
      return false
    },
    /**
     * 批量同步时该行该列是否允许写入
     */
    canSyncBatchFieldToRow (field, row) {
      if (field === 'usingUnit' || field === 'OIDNO') return !this.isEdit
      if (field === 'finalDisc') return !this.isDiscInputDisabled(row)
      return true
    },
    isBatchFieldValueEqual (current, target) {
      if (current === target) return true
      const cur = current == null ? '' : String(current).trim()
      const tgt = target == null ? '' : String(target).trim()
      return cur === tgt
    },
    /**
     * 批量编辑：第一行按回车将当前列同步到其余行
     */
    handleBatchColumnSync (field, rowIndex = 0) {
      if (!this.batchEditMode || this.detailList.length < 2 || rowIndex !== 0) return
      const firstRow = this.detailList[0]
      if (!this.canSyncBatchFieldToRow(field, firstRow)) {
        this.$message.warning('该列不允许批量修改')
        return
      }
      const value = firstRow[field]
      let syncCount = 0
      for (let i = 1; i < this.detailList.length; i++) {
        const row = this.detailList[i]
        if (!this.canSyncBatchFieldToRow(field, row)) continue
        if (this.isBatchFieldValueEqual(row[field], value)) continue
        this.$set(row, field, value)
        if (field === 'finalDisc') this.handleDiscInput(row)
        if (field === 'finalPrice') this.handlePriceInput(row)
        syncCount++
      }
      if (syncCount > 0) {
        this.$message.success(`已同步 ${syncCount} 行`)
      }
    },
    normalizeDiscWithFixedPrice (row) {
      if (!row) return
      if (row.finalPrice !== undefined && row.finalPrice !== null && String(row.finalPrice).trim() !== '') {
        row.finalDisc = '1'
      }
    },
    handleDiscInput (row) {
      if (row.finalPrice) {
        row.finalDisc = '1'
        return
      }
      let value = row.finalDisc
      if (value) {
        // 移除非数字和小数点的字符
        value = value.replace(/[^\d.]/g, '')
        // 允许用户直接输入 .1 这种写法
        if (value.startsWith('.')) value = `0${value}`
        // 只保留第一个小数点
        const parts = value.split('.')
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('')
        }
        // 限制整数部分只能是0或1
        if (parts[0] && parseInt(parts[0]) > 1) {
          value = '1'
        }
        // 如果整数部分是1，不允许有小数部分（最大值就是1）
        if (parts[0] === '1' && parts.length > 1 && parts[1]) {
          value = '1'
        }
        // 限制小数位数为3位
        const newParts = value.split('.')
        if (newParts.length === 2 && newParts[1].length > 3) {
          value = newParts[0] + '.' + newParts[1].substring(0, 3)
        }

        // 不允许输入 0（必须为正数且 <= 1）
        const numeric = Number(value)
        if (!Number.isNaN(numeric) && numeric === 0 && !value.endsWith('.')) {
          value = ''
        }

        row.finalDisc = value
      }
    },
    /**
     * 固定价输入时限制只能输入数字
     */
    handlePriceInput (row) {
      let value = row.finalPrice
      if (value) {
        // 移除非数字和小数点的字符
        value = value.replace(/[^\d.]/g, '')
        // 只保留第一个小数点
        const parts = value.split('.')
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('')
        }
        // 限制小数位数为2位
        if (parts.length === 2 && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2)
        }
        row.finalPrice = value
      }
      this.normalizeDiscWithFixedPrice(row)
    },
    /**
     * 新增一行详细信息
     */
    handleAddRow () {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持新增行')
        return
      }
      let newRow
      if (this.detailList && this.detailList.length > 0) {
        const lastRow = this.detailList[this.detailList.length - 1]
        newRow = { ...lastRow, OIDNO: '' }
      } else {
        newRow = {
          siteContact: '',
          siteContactTel: '',
          usingUnit: '',
          houseName: '',
          OIDNO: '',
          unifiedCreditCode: '',
          inspectionMonth: '',
          USE_UNT_ADDR: '',
          finalDisc: '',
          finalPrice: '',
          remark: ''
        }
      }
      this.normalizeDiscWithFixedPrice(newRow)
      this.detailList.push(newRow)
    },
    /**
     * 删除一行详细信息
     */
    handleDeleteRow (index) {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持删除行')
        return
      }
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => { })
    },
    /**
     * 处理Excel文件导入
     */
    handleExcelImport (file) {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持导入')
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
          this.parseExcelData(jsonData)
        } catch (error) {
          this.$message.error('Excel文件解析失败，请检查文件格式')
          console.error(error)
        }
      }
      reader.readAsArrayBuffer(file.raw)
    },
    /**
     * 解析Excel数据并填充到详细信息列表
     * 列顺序：现场联系人、现场联系人电话、使用单位、小区名称、识别码、统一信用代码、到检年月、单位使用地址、折扣、固定价、备注
     */
    parseExcelData (jsonData) {
      if (!jsonData || jsonData.length < 2) {
        this.$message.warning('Excel文件中没有数据')
        return
      }
      const importedData = []
      for (let i = 1; i < jsonData.length; i++) {
        const row = jsonData[i]
        if (!row || row.length === 0) continue
        const detailRow = {
          siteContact: row[0] ? String(row[0]).trim() : '',
          siteContactTel: row[1] ? String(row[1]).trim() : '',
          usingUnit: row[2] ? String(row[2]).trim() : '',
          houseName: row[3] ? String(row[3]).trim() : '',
          OIDNO: row[4] ? String(row[4]).trim() : '',
          unifiedCreditCode: row[5] ? String(row[5]).trim() : '',
          inspectionMonth: row[6] ? this.parseExcelDate(row[6]) : '',
          USE_UNT_ADDR: row[7] ? String(row[7]).trim() : '',
          finalDisc: row[8] ? String(row[8]).trim() : '',
          finalPrice: row[9] ? String(row[9]).trim() : '',
          remark: row[10] ? String(row[10]).trim() : ''
        }
        this.normalizeDiscWithFixedPrice(detailRow)
        importedData.push(detailRow)
      }
      if (importedData.length > 0) {
        if (this.detailList.length > 0) {
          this.$confirm(`当前已有 ${this.detailList.length} 条数据，是否要覆盖？选择"取消"将追加数据。`, '提示', {
            confirmButtonText: '覆盖',
            cancelButtonText: '追加',
            type: 'warning'
          }).then(() => {
            this.detailList = importedData
            this.$message.success(`成功导入 ${importedData.length} 条数据（覆盖模式）`)
          }).catch(() => {
            this.detailList.push(...importedData)
            this.$message.success(`成功导入 ${importedData.length} 条数据（追加模式）`)
          })
        } else {
          this.detailList = importedData
          this.$message.success(`成功导入 ${importedData.length} 条数据`)
        }
      } else {
        this.$message.warning('未能解析到有效数据')
      }
    },
    parseExcelDate (value) {
      if (!value) return ''
      if (typeof value === 'string') return value
      if (typeof value === 'number') {
        const date = XLSX.SSF.parse_date_code(value)
        if (date) {
          const year = date.y
          const month = String(date.m).padStart(2, '0')
          return `${year}-${month}`
        }
      }
      return String(value)
    },
    isValidMonthFormat (value) {
      if (!value) return true
      if (typeof value !== 'string') return false
      const monthValue = value.trim()
      const match = monthValue.match(/^(\d{4})-(\d{2})$/)
      if (!match) return false
      const month = Number(match[2])
      return month >= 1 && month <= 12
    },
    validateDetailDateFields () {
      const invalidInspectionRows = []
      this.detailList.forEach((row, index) => {
        if (!this.isValidMonthFormat(row.inspectionMonth)) {
          invalidInspectionRows.push(index + 1)
        }
      })
      if (invalidInspectionRows.length > 0) {
        return {
          valid: false,
          message: `第 ${invalidInspectionRows.join(', ')} 行的到检年月格式不正确，请使用 yyyy-MM`
        }
      }
      return { valid: true, message: '' }
    },
    /**
     * 显示弹出层 - 新增
     */
    showAdd () {
      this.visible = true
      this.isEdit = false
      this.isSingleEdit = false
      this.resetForm()
    },
    /**
     * 显示弹出层 - 单条修改
     * @param {Object} row - 行数据（来自列表接口）
     */
    async showEditSingle (row) {
      this.visible = true
      this.isEdit = true
      this.isSingleEdit = true
      this.resetForm()

      if (!row.custPid) {
        this.$message.warning('该记录缺少数据标识，无法加载详情')
        return
      }

      this.loading = true
      try {
        let custDetailData = null
        // 保存custPid用于更新
        this.editId = row.custPid

        // 填充客户编码
        this.headerForm.compCode = row.compCode || ''

        // 根据 compCode 获取客户详情（包含开票主体、跟单员等信息）
        if (row.compCode) {
          const custRes = await queryCustBaseDetail(row.compCode)
          if (custRes && custRes.retCode === 'ok' && custRes.additionalData) {
            const custData = custRes.additionalData
            custDetailData = custData
            this.headerForm.customerName = custData.compName || row.compName || ''
            this.headerForm.followUpPerson = custData.followPerson || ''
            this.headerForm.projectSource = custData.projectSource || ''
            this.headerForm.invoiceEntity = custData.compEntityName || ''
            this.headerForm.status = custData.enabledState === 0 ? '完结' : '进行中'
          }
        }

        // 联系人/联系电话改为手动维护，编辑时优先使用业务字段回填
        this.headerForm.contactPerson = row.businessContact || ''
        this.headerForm.contactPhone = row.businessContactTel || ''

        // 兼容历史字段 businessContactAndTel
        if (row.businessContactAndTel && !this.headerForm.contactPerson && !this.headerForm.contactPhone) {
          const parts = row.businessContactAndTel.split('/')
          if (parts.length >= 1) this.headerForm.contactPerson = parts[0] || ''
          if (parts.length >= 2) this.headerForm.contactPhone = parts[1] || ''
        }

        // 客户名称兜底
        if (!this.headerForm.customerName && row.compName) {
          this.headerForm.customerName = row.compName
        }
        this.ensureCurrentCustomerOption(this.headerForm.compCode, this.headerForm.customerName, {
          followUpPerson: this.headerForm.followUpPerson,
          projectSource: this.headerForm.projectSource,
          invoiceEntity: this.headerForm.invoiceEntity,
          status: this.headerForm.status
        })

        const rebateData = this.buildEditRebateData({
          rebateSources: [
            { value: row.rebateList, name: 'rebateList' },
            { value: custDetailData && custDetailData.rebateList, name: 'custDetailData.rebateList' }
          ],
          rebateTypeSources: [
            row.rebateType,
            custDetailData && custDetailData.rebateType
          ]
        })
        // 加载返点配置
        if (rebateData) {
          console.log('单条修改-返点配置:', rebateData)
          this.loadRebateConfig(rebateData, {})
        }

        // 填充详细信息（单条数据）
        const singleFinalDisc = (row.finalDisc !== undefined && row.finalDisc !== null) ? String(row.finalDisc).trim() : ''
        const singleFinalPrice = (row.finalPrice !== undefined && row.finalPrice !== null) ? String(row.finalPrice) : ''
        this.detailList = [{
          custPid: row.custPid || '',
          entrustNum: row.entrustNum || '',
          siteContact: row.siteContact || '',
          siteContactTel: row.siteContactTel || '',
          usingUnit: row.usingUnit || '',
          houseName: row.houseName || '',
          OIDNO: row.OIDNO || '',
          unifiedCreditCode: row.unifiedCreditCode || '',
          inspectionMonth: row.inspectionMonth || '',
          USE_UNT_ADDR: row.USE_UNT_ADDR || '',
          finalDisc: singleFinalDisc,
          finalPrice: singleFinalDisc === '1' ? singleFinalPrice : '',
          remark: row.remark || ''
        }]
        this.loading = false
      } catch (err) {
        this.loading = false
        console.error('加载详情失败:', err)
        this.$message.error('加载详情失败')
      }
    },
    /**
     * 显示弹出层 - 批量修改
     * @param {Object} row - 行数据，包含 batchNum（来自列表接口）
     */
    async showEdit (row) {
      this.visible = true
      this.isEdit = true
      this.isSingleEdit = false
      this.resetForm()

      // 必须有批次号才能编辑
      if (!row.batchNum) {
        this.$message.warning('该记录没有批次号，无法加载详情')
        return
      }

      this.loading = true
      try {
        let custDetailData = null
        // 按批次号查询同批次的所有数据
        const res = await getBatchDetail(row.batchNum)
        if (!(res && res.retCode === 'ok')) {
          this.loading = false
          this.$message.error((res && res.retMsg) || '获取详情失败')
          return
        }

        // 解析返回数据，兼容多种格式
        let dataList = []
        const additionalData = res.additionalData || res.data || res
        if (Array.isArray(additionalData)) {
          dataList = additionalData
        } else if (additionalData && Array.isArray(additionalData.records)) {
          dataList = additionalData.records
        } else if (additionalData && Array.isArray(additionalData.list)) {
          dataList = additionalData.list
        } else if (additionalData && typeof additionalData === 'object') {
          dataList = [additionalData]
        }

        console.log('getBatchDetail返回数据:', res)

        if (dataList.length === 0) {
          this.loading = false
          this.$message.warning('未找到该批次的数据')
          return
        }

        // 取第一条数据的基本信息
        const firstItem = dataList[0]

        // 保存批次号用于更新
        this.editId = row.batchNum

        // 填充客户编码
        const compCode = firstItem.compCode || row.compCode || ''
        this.headerForm.compCode = compCode

        // 根据 compCode 获取客户详情（包含开票主体、跟单员等信息）
        if (compCode) {
          const custRes = await queryCustBaseDetail(compCode)
          if (custRes && custRes.retCode === 'ok' && custRes.additionalData) {
            const custData = custRes.additionalData
            custDetailData = custData
            this.headerForm.customerName = custData.compName || row.compName || ''
            this.headerForm.followUpPerson = custData.followPerson || ''
            this.headerForm.projectSource = custData.projectSource || ''
            this.headerForm.invoiceEntity = custData.compEntityName || ''
            this.headerForm.status = custData.enabledState === 0 ? '完结' : '进行中'
          }
        }

        // 联系人/联系电话改为手动维护，编辑时优先使用业务字段回填（取批次第一条）
        this.headerForm.contactPerson = firstItem.businessContact || ''
        this.headerForm.contactPhone = firstItem.businessContactTel || ''

        // 兼容历史字段 businessContactAndTel
        if (row.businessContactAndTel && !this.headerForm.contactPerson && !this.headerForm.contactPhone) {
          const parts = row.businessContactAndTel.split('/')
          if (parts.length >= 1) this.headerForm.contactPerson = parts[0] || ''
          if (parts.length >= 2) this.headerForm.contactPhone = parts[1] || ''
        }

        // 客户名称兜底
        if (!this.headerForm.customerName && row.compName) {
          this.headerForm.customerName = row.compName
        }
        this.ensureCurrentCustomerOption(this.headerForm.compCode, this.headerForm.customerName, {
          followUpPerson: this.headerForm.followUpPerson,
          projectSource: this.headerForm.projectSource,
          invoiceEntity: this.headerForm.invoiceEntity,
          status: this.headerForm.status
        })

        const rebateData = this.buildEditRebateData({
          rebateSources: [
            { value: row.rebateList, name: 'rebateList' },
            { value: firstItem.rebateList, name: 'firstItem.rebateList' },
            { value: custDetailData && custDetailData.rebateList, name: 'custDetailData.rebateList' }
          ],
          rebateTypeSources: [
            row.rebateType,
            firstItem.rebateType,
            custDetailData && custDetailData.rebateType
          ]
        })
        // 加载返点配置
        if (rebateData) {
          console.log('批量修改-返点配置:', rebateData)
          this.loadRebateConfig(rebateData, {})
        }

        // 映射所有明细数据
        this.detailList = dataList.map(item => {
          const finalDisc = (item.finalDisc !== undefined && item.finalDisc !== null) ? String(item.finalDisc).trim() : ''
          const finalPrice = (item.finalPrice !== undefined && item.finalPrice !== null) ? String(item.finalPrice) : ''
          return ({
            custPid: item.custPid || '',
            entrustNum: item.entrustNum || '',
            siteContact: item.siteContact || '',
            siteContactTel: item.siteContactTel || '',
            usingUnit: item.usingUnit || '',
            houseName: item.houseName || '',
            OIDNO: item.OIDNO || item.oidno || '',
            unifiedCreditCode: item.unifiedCreditCode || '',
            inspectionMonth: item.inspectionMonth || '',
            USE_UNT_ADDR: item.USE_UNT_ADDR || item.useUntAddr || '',
            finalDisc,
            finalPrice: finalDisc === '1' ? finalPrice : '',
            remark: item.remark || ''
          })
        })
        this.loading = false
      } catch (err) {
        this.loading = false
        console.error('获取详情失败:', err)
        this.$message.error('获取详情失败')
      }
    },
    /**
     * 重置表单
     */
    resetForm () {
      this.headerForm = {
        compCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        followUpPerson: '',
        projectSource: '',
        invoiceEntity: '',
        status: '',
        rebatePlan: '',
        ratioValue: '',
        fixedRebateStart: '',
        fixedRebateEnd: '',
        fixedRebateRemark: '',
        unitRebateAmount: '',
        rebateTiers: []
      }
      this.detailList = []
      this.editId = ''
      this.isSingleEdit = false
      this.batchEditMode = false
      this.customerOptions = []

      this.$nextTick(() => {
        if (this.$refs.headerForm) {
          this.$refs.headerForm.clearValidate()
        }
      })
    },
    /**
     * 关闭弹出层
     */
    handleClose () {
      this.visible = false
      this.resetForm()
    },
    /**
     * 提交表单
     */
    handleSubmit () {
      this.$refs.headerForm.validate((valid) => {
        if (!valid) {
          this.$message.warning('请检查基本信息填写是否正确')
          return false
        }

        if (!this.headerForm.compCode) {
          this.$message.warning('请选择客户名称')
          return false
        }

        if (this.detailList.length === 0) {
          this.$message.warning('请至少添加一条详细信息')
          return false
        }

        const invalidRows = []
        this.detailList.forEach((row, index) => {
          if (!row.OIDNO) {
            invalidRows.push(index + 1)
          }
        })
        if (invalidRows.length > 0) {
          this.$message.warning(`第 ${invalidRows.join(', ')} 行的识别码不能为空`)
          return false
        }

        const invalidDiscRows = []
        this.detailList.forEach((row, index) => {
          const discStr = (row.finalDisc !== undefined && row.finalDisc !== null) ? String(row.finalDisc).trim() : ''
          if (!discStr) return
          const discNum = Number(discStr)
          if (Number.isNaN(discNum) || discNum <= 0 || discNum > 1) {
            invalidDiscRows.push(index + 1)
          }
        })
        if (invalidDiscRows.length > 0) {
          this.$message.warning(`第 ${invalidDiscRows.join(', ')} 行折扣不合法：需大于0且不超过1`)
          return false
        }

        const dateValidation = this.validateDetailDateFields()
        if (!dateValidation.valid) {
          this.$message.warning(dateValidation.message)
          return false
        }

        this.loading = true

        if (this.isEdit) {
          if (this.isSingleEdit) {
            // 单条修改 - 只提交一条数据
            const submitObj = {
              ...this.detailList[0],
              compCode: this.headerForm.compCode,
              businessContact: this.headerForm.contactPerson,
              businessContactTel: this.headerForm.contactPhone,
              custPid: this.editId
            }
            updateCustInfo(submitObj).then(res => {
              this.loading = false
              if (res && res.retCode === 'ok') {
                this.$message.success('修改成功')
                this.handleClose()
                this.$emit('refresh')
              } else {
                this.$message.error(res.retMsg || '修改失败')
              }
            }).catch(err => {
              this.loading = false
              this.$message.error(err.message || '修改失败')
            })
          } else {
            // 整批修改 - 提交所有数据，带上batchNum
            const submitArray = this.detailList.map(item => ({
              ...item,
              compCode: this.headerForm.compCode,
              businessContact: this.headerForm.contactPerson,
              businessContactTel: this.headerForm.contactPhone,
              batchNum: this.editId  // editId存的是batchNum
            }))
            updateCustInfo(submitArray).then(res => {
              this.loading = false
              if (res && res.retCode === 'ok') {
                this.$message.success('修改成功')
                this.handleClose()
                this.$emit('refresh')
              } else {
                this.$message.error(res.retMsg || '修改失败')
              }
            }).catch(err => {
              this.loading = false
              this.$message.error(err.message || '修改失败')
            })
          }
        } else {
          const submitArray = this.detailList.map(item => ({
            ...item,
            compCode: this.headerForm.compCode,
            businessContact: this.headerForm.contactPerson,
            businessContactTel: this.headerForm.contactPhone
          }))
          saveCustInfo(submitArray).then(res => {
            this.loading = false
            if (res && res.retCode === 'ok') {
              this.$message.success('新增成功')
              this.handleClose()
              this.$emit('refresh')
            } else {
              this.$message.error(res.retMsg || '新增失败')
            }
          }).catch(err => {
            this.loading = false
            this.$message.error(err.message || '新增失败')
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}

.header-section,
.detail-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  border-bottom: 2px solid #409eff;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.batch-edit-control {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.el-form-item {
  margin-bottom: 18px;
}

.dialog-footer {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 只读字段样式 */
.el-input.is-disabled >>> .el-input__inner,
.el-input[readonly] >>> .el-input__inner {
  background-color: #f5f7fa;
  color: #606266;
  cursor: not-allowed;
}

/* 表格内输入框样式优化 */
.el-table >>> .el-input__inner,
.el-table >>> .el-input-number__inner {
  border: 1px solid #dcdfe6;
}

.el-table >>> .el-input__inner:focus,
.el-table >>> .el-input-number__inner:focus {
  border-color: #409eff;
}

/* 输入框后缀符号垂直居中 */
.el-input >>> .el-input__suffix {
  display: flex;
  align-items: center;
}
</style>
